<template>
  <Modal
    :open="open"
    :title="documentTitle"
    size="xl"
    variant="gray"
    :close-on-overlay-click="false"
    @close="emit('close')"
  >
    <div v-if="loading" class="text-sm text-slate-400">Carregando...</div>
    <template v-else-if="doc">
      <p class="text-sm text-zinc-500 dark:text-zinc-400">
        Versão {{ doc.version }} · Última atualização: {{ formatDate(doc.created_at) }}
      </p>
      <div v-html="renderLegalMarkdown(doc.content)" />
    </template>
    <p v-else class="text-sm text-danger-500">Não foi possível carregar o documento.</p>

    <template #footer>
      <div class="flex justify-end">
        <button type="button" class="btn-secondary" @click="emit('close')">
          Fechar
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import Modal from '../ui/Modal.vue'
import apiClient from '../../api/client.js'
import { renderLegalMarkdown } from '../../utils/legalMarkdown.js'

const props = defineProps({
  open: { type: Boolean, default: false },
  document: { type: String, default: null }, // 'terms' | 'privacy'
})

const emit = defineEmits(['close'])

const documentTitle = computed(() => {
  if (props.document === 'terms') return 'Termos de Uso'
  if (props.document === 'privacy') return 'Política de Privacidade'
  return ''
})

const documentType = computed(() => props.document === 'terms' ? 'TERMS_OF_USE' : 'PRIVACY_POLICY')

const doc = ref(null)
const loading = ref(false)
const formatDate = (iso) => iso ? new Date(iso).toLocaleDateString('pt-BR') : ''

watch(() => props.open, async (isOpen) => {
  if (!isOpen || !props.document) return
  doc.value = null
  loading.value = true
  try {
    const { data } = await apiClient.get('/public/legal-documents/current', { params: { document_type: documentType.value } })
    doc.value = data.data
  } catch {
    doc.value = null
  } finally {
    loading.value = false
  }
})
</script>
